import { urls } from '@zapier/identity-utils';

/**
 * Only forward next to the SAML SSO redirect when it's a real deep link.
 * Bare logins (no next, or the default) keep the exact pre-existing
 * redirect URL. Deliberately NOT used for the login error redirects,
 * which carry next unconditionally (including the default).
 */
export function nextForSsoRedirect(
  next: string | undefined
): string | undefined {
  return !next || next === urls.DEFAULT_LOGIN_NEXT ? undefined : next;
}
